/**
* 基础菜单 大数据
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 系统配置表单 -->
        <el-form :model="editForm" ref="editForm" class="my-form">
            <el-form-item :label="item.config_remark" v-for="(item, index) in system_config" :key="index">
                <el-input
                    @input="handle_input(index, item.config_value)"
                    size="small"
                    v-model="editForm.system_config[index]['config_value']"
                    auto-complete="off"
                    :placeholder="item.config_remark"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" class="title" @click="save()">保存配置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// 引入config
import config from '../../../config/config.js'

import {get_system_config, update_system_config} from '../../api/userMG'

export default {
    data() {
        return {
            config: config,
            system_config: [],

            is_loading: false,

            editForm: {
                token: localStorage.getItem('logintoken'),
                system_config: [],
            },
        }
    },
    // 注册组件
    components: {

    },

    created() {
        this.get_system_config()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        handle_input(index, value) {

            this.$forceUpdate();
        },
        // 获取公司列表
        get_system_config() {
            let that = this;

            get_system_config()
                .then(res => {

                    if (res.status != 200) {
                        this.$message({
                            type: 'info',
                            message: res.msg
                        })
                    } else {
                        that.system_config = res.data;
                        that.editForm.system_config = res.data;
                    }
                })
                .catch(err => {
                    this.is_loading = false
                    this.$message.error('菜单加载失败，请稍后再试！')
                })
        },
        //保存配置
        save(){
            let that = this;

            update_system_config({
                token: that.editForm.token,
                config_items: JSON.stringify(that.editForm.system_config)
            }).then(res => {

                if (res.status != 200) {
                    this.$message({
                        type: 'info',
                        message: res.message
                    })
                } else {
                    this.$message({
                        type: 'success',
                        message: '更新成功'
                    })
                }

            }).catch(err => {
                this.is_loading = false
                this.$message.error('菜单加载失败，请稍后再试！')
            })
        }
    }
}
</script>

<style scoped>
.my-form{
    padding-top: 20px; width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/bigdata/system_config.vue